(function() {
'use strict';

angular
    .module('core')
    .directive('loadingSpinner', loadingSpinner);

function loadingSpinner(resourceService) {
    return {
        restrict: 'A',
        scope: {
            block: '=loadingSpinner',
            message: '@message'
        },
        link(scope, el) {
            const loadingTemplate = `${'<div class="content">' +
                                    '    <div class="loading-screen">' +
                                    '        <h3>'}${resourceService.get(scope.message ? scope.message : 'LOADING')}</h3>` +
                                    '        <div class="spinner-horizontal"></div>' +
                                    `        <p>${resourceService.get('THISMAYTAKE')}</p>` +
                                    '    </div>' +
                                    '</div>';
            const wait = angular.element(loadingTemplate);

            el.css('display', 'none');
            el.after(wait);

            const sw = scope.$watch('block', function(val) {
                if (val) {
                    el.css('display', '');
                    wait.css('display', 'none');
                    sw();
                }
            });
        }
    };
}
})();
